<template>
  <section-hoc mode="full" :variant="variant" class="wrapper" size="cover">
    <h4 class="title">
      <slot></slot>
    </h4>
  </section-hoc>
</template>

<script>
import SectionHoc from "./SectionHoc";

export default {
  components: { "section-hoc": SectionHoc },
  props: {
    variant: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style scoped>
.title {
  color: var(--lt1);
  text-align: left;
}

@media (max-width: 425px) {
  .title {
    text-align: center;
  }
}
</style>
